import { UserResponse, UserListResponse } from "@/types/userTypes";
import { Client } from "./client";

export class UserController {
  client: Client;

  constructor(client?: Client) {
    this.client = client ?? new Client();
  }

  readByEmailOrCreate(): Promise<UserResponse> {
    return this.client.read('/api/users/email');
  }

  readAllByPropelOrgId(): Promise<UserListResponse> {
    return this.client.read('/api/users');
  }
}
